/**
 * URL helpers shared by RCS loader code (main thread and workers).
 */

/**
 * @returns {string|undefined}
 */
function getDocumentBaseUrl() {
  if (typeof self !== 'undefined' && self.location?.href) {
    return self.location.href;
  }
  return undefined;
}

/**
 * @param {string|null|undefined} url - URL to test (absolute or relative to the document/worker)
 * @param {string} [base] - Base URL for resolving relative paths
 * @returns {boolean} true if `url` resolves to a loopback address. Returns false for null/empty
 *                    input — a missing URL means "no local resource", regardless of where the
 *                    page is served from, so callers should route through the proxy.
 */
export function isLocalhostUrl(url, base = getDocumentBaseUrl()) {
  if (!url) {
    return false;
  }
  try {
    const host = new URL(url, base).hostname;
    return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
  } catch {
    return false;
  }
}